<template>
  <Layout>
    <SEOStructuredData 
      :data="structuredData"
      type="website"
    />
    <div class="buy-licoin container">
      <div class="row justify-content-center">
        <div class="col-md-8">
          <div class="card">
            <div class="card-header">
              <h4 class="mb-0">確認訂單</h4>
            </div>
            <div class="card-body">
              <div class="order-details">
                <div class="mb-3">
                  <h5>訂單內容</h5>
                  <p>購買數量：{{ amount }} LiCoin</p>
                  <p>單價：100 元</p>
                  <p>總金額：{{ totalAmount }} 元</p>
                </div>
                <div class="d-flex justify-content-end gap-2">
                  <button class="btn btn-secondary" @click="cancelOrder">取消</button>
                  <button class="btn btn-primary" @click="processPayment" :disabled="loading">
                    {{ loading ? '處理中...' : '付款' }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Layout.vue'
import { mapActions, mapState } from 'vuex'
import SEOStructuredData from '@/components/SEOStructuredData.vue'

export default {
  name: 'BuyLiCoin',
  components: {
    Layout,
    SEOStructuredData
  },
  data() {
    return {
      amount: 0,
      loading: false
    }
  },
  computed: {
    ...mapState(['storeInfo']),
    totalAmount() {
      return this.amount * 100
    },
    structuredData() {
      const storeName = this.storeInfo?.name || '購物平台'
      return {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": `購買 LiCoin - ${storeName}`,
        "description": `${storeName}購買 LiCoin 虛擬貨幣，安全便捷的數位支付`,
        "url": window.location.href
      }
    }
  },
  created() {
    this.amount = parseInt(this.$route.query.amount) || 0
    if (!this.amount) {
      this.$router.push('/licoin')
    }
  },
  mounted() {
    this.fetchStoreInfo()
  },
  methods: {
    ...mapActions(['mintLiCoin', 'fetchStoreInfo']),
    cancelOrder() {
      this.$router.push('/licoin')
    },
    async processPayment() {
      try {
        this.loading = true
        await this.mintLiCoin(this.amount)
        this.$router.push('/licoin')
      } catch (error) {
        console.error('Payment failed:', error)
        alert('付款失敗，請稍後再試')
      } finally {
        this.loading = false
      }
    }
  },
  metaInfo() {
    const storeName = this.storeInfo?.name || '購物平台'
    
    return {
      title: `購買 LiCoin - ${storeName}`,
      meta: [
        { name: 'description', content: `${storeName}購買 LiCoin 虛擬貨幣，安全便捷的數位支付` },
        { name: 'keywords', content: `${storeName},LiCoin,虛擬貨幣,數位支付,購買` },
        { property: 'og:title', content: `購買 LiCoin - ${storeName}` },
        { property: 'og:description', content: `${storeName}購買 LiCoin 虛擬貨幣，安全便捷的數位支付` },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: window.location.href },
        { name: 'twitter:title', content: `購買 LiCoin - ${storeName}` },
        { name: 'twitter:description', content: `${storeName}購買 LiCoin 虛擬貨幣，安全便捷的數位支付` }
      ]
    }
  }
}
</script>

<style scoped>
.buy-licoin {
  margin-top: 80px;
}
.order-details {
  padding: 1rem;
}
</style> 